import { useState } from 'react'

// Hook to manage progressive numbers (e.g. 25.001)
// In a real app, this would call an API to ensure atomicity
export const useProgressiveNumber = () => {
  const suggestNext = (
    type: string,
    year: number = new Date().getFullYear(),
  ): string => {
    const key = `progressive_${type}_${year}`
    const last = parseInt(localStorage.getItem(key) || '0', 10)
    const next = last + 1

    // Format: YY.NNN (e.g. 25.001)
    const yearShort = year.toString().slice(-2)
    const numberPadded = next.toString().padStart(3, '0')

    return `${yearShort}.${numberPadded}`
  }

  const reserve = (
    type: string,
    numberStr: string,
    year: number = new Date().getFullYear(),
  ) => {
    // Extract number part
    const parts = numberStr.split('.')
    if (parts.length !== 2) return

    const num = parseInt(parts[1], 10)
    const key = `progressive_${type}_${year}`
    const currentMax = parseInt(localStorage.getItem(key) || '0', 10)

    if (num > currentMax) {
      localStorage.setItem(key, num.toString())
    }
  }

  const checkAvailability = (type: string, numberStr: string): boolean => {
    // In a real app, this would check against the database
    // For now, we'll just check if it's not already reserved in localStorage
    const parts = numberStr.split('.')
    if (parts.length !== 2) return false

    const year = parseInt('20' + parts[0], 10)
    const num = parseInt(parts[1], 10)
    const key = `progressive_${type}_${year}`
    const currentMax = parseInt(localStorage.getItem(key) || '0', 10)

    // Available if it's greater than current max (not yet used)
    return num > currentMax
  }

  return { suggestNext, reserve, checkAvailability }
}
